import { call, put, takeEvery } from "redux-saga/effects";
import { transactionService } from "../../services/dependency.injection";
import { setPaymentDetail } from "../actions/action";
import { TransactionActionTypes } from "../actions/actionTypes";

function* callGetPaymentDetail({ payload: reference }) {
    const response = yield call(transactionService.getPaymentById, reference);

    if (response.isRight()) {
        yield put(setPaymentDetail(response.value.getValue()));
    } else {
        // yield put(setProcessLoading(false));
    }
}

export function* watchCallGetPaymentDetail() {
    yield takeEvery<any>(TransactionActionTypes.GET_PAYMENT_DETAILS, callGetPaymentDetail);
}